<template>
  <div>
    <div class="suspension" v-if="false">
      <div style="box-shadow: 0 5px 20px #efefef">
        <div class="boxed" style="border-radius: 4px 0 0 0" @mouseenter="account" @mouseleave="accountout">
          <p class="pl">
            <img v-if="official" src="../../static/images/xiaotubiao/1.png" alt="" />
            <img v-else src="../../static/images/xiaotubiao/6.png" alt="" />
          </p>
          <!-- <span>微信公众号</span> -->
          <span class="box_span"></span>
          <div style="position: absolute;top: 0;right: 48px;width: 12px;height: 184px;" v-if="official"></div>
          <div class="tesr" :class="official ? 'xfk2' : !official2 ? '' : 'xfk2 xfk3'">
            <div class="d1">扫描二维码</div>
            <div class="d2">关注微信公众号</div>
            <p class="pf"><img src="../assets/images/erweima2.jpg" alt="" /></p>
          </div>
          <!-- <div class="ters" v-if="official">
            <img src="../assets/images/sanjiao.png" alt="" />
          </div> -->
        </div>
        <div class="boxed" @mouseenter="mouse" @mouseleave="seout" v-if="false">
          <p class="pl">
            <img v-if="applet" src="../../static/images/xiaotubiao/2.png" alt="" />
            <img v-else src="../../static/images/xiaotubiao/7.png" alt="" />
          </p>
          <!-- <span>微信小程序</span> -->
          <span class="box_span"></span>
          <div style="position: absolute;top: 0;right: 48px;width: 12px;height: 184px;" v-if="applet"></div>
          <div class="tesr" :class="applet ? 'xfk2' : !applet2 ? '' : 'xfk2 xfk3'">
            <div class="d1">扫描二维码</div>
            <div class="d2">打开微信小程序</div>
            <p class="pf">
              <img src="../assets/images/xiaochengxu2.jpg" alt="" />
            </p>
          </div>
          <!-- <div class="ters" v-if="applet">
            <img src="../assets/images/sanjiao.png" alt="" />
          </div> -->
        </div>
        <div class="boxed" @mouseenter="customer" @mouseleave="customerout">
          <p class="pl">
            <img v-if="service" src="../../static/images/xiaotubiao/3.png" alt="" />
            <img v-else src="../../static/images/xiaotubiao/8.png" alt="" />
          </p>
          <!-- <span>客服热线</span> -->
          <span class="box_span"></span>
          <div style="position: absolute;top: 0;right: 48px;width: 12px;height: 184px;" v-if="service"></div>
          <div class="tesr" :class="service ? 'xfk2' : !service2 ? '' : 'xfk2 xfk3'">
            <div class="d1" style="margin-top: 16px;">微信咨询</div>
            <p class="pf">
              <img src="../../static/images/xiaotubiao/微信(2).jpg" alt="" />
            </p>
          </div>
          <!-- <div class="ters" v-if="service">
            <img src="../assets/images/sanjiao.png" alt="" />
          </div> -->
        </div>
        <div class="boxed" style="border-radius: 0 0 0 3.9936px" @mouseenter="consulting"
          @mouseleave="consultingomerout">
          <p class="pl">
            <img v-if="texsd" src="../../static/images/xiaotubiao/4.png" alt="" />
            <img v-else src="../../static/images/xiaotubiao/9.png" alt="" />
          </p>
          <div style="position: absolute;top: 0;right: 48px;width: 12px;height: 184px;" v-if="texsd"></div>
          <div class="tesr" :class="texsd ? 'xfk2' : !texsd2 ? '' : 'xfk2 xfk3'">
            <div class="d1" style="margin-top: 16px;">QQ咨询</div>
            <p class="pf">
              <img src="../../static/images/xiaotubiao/qq.png" alt="" />
            </p>
          </div>
        </div>
        <div class="boxed" style="border-radius: 0 0 0 3.9936px" @mouseenter="yfjyting" @mouseleave="yfjyomerout">
          <p class="pl" style="color:#dcd7d7;">
            App
            <!-- <img v-if="texsd3" src="../../static/images/xiaotubiao/4.png" alt="" />
            <img v-else src="../../static/images/xiaotubiao/9.png" alt="" /> -->
          </p>
          <div style="position: absolute;top: 0;right: 48px;width: 12px;height: 184px;" v-if="texsd3"></div>
          <div class="tesr" :class="texsd3 ? 'xfk2' : !texsd4 ? '' : 'xfk2 xfk3'">
            <div class="d1">扫描二维码</div>
            <div class="d2">下载app</div>
            <p class="pf">
              <img src="../../static/images/yfjy.png" alt="" />
            </p>
          </div>
        </div>
        <div v-if="isUserAgent == -1" class="boxed" style="border-radius: 0 0 0 3.9936px" @mouseenter="exeting"
          @mouseleave="exeout">
          <p class="pl" style="color:#dcd7d7;">
            exe
          </p>
          <div style="position: absolute;top: 0;right: 48px;width: 12px;height: 184px;" v-if="texsexe"></div>
          <div class="tesr" style="height: 40px !important;overflow: hidden;"
            :class="texsexe ? 'xfk2' : !texsexe2 ? '' : 'xfk2 xfk3'">
            <el-link href="https://yfjyw.com.cn/win32/YiFangEducation.zip" style="display: block;width: 100px;margin: 10px 22px;"
              type="primary">下载桌面版应用</el-link>
          </div>
        </div>
      </div>
      <div class="boxed" @mouseenter="topsd" @mouseleave="topsdomerout" v-show="isShow"
        style="border-radius: 4px 0 0 4px; margin-top: 20.0064px;box-shadow: 0 5px 20px #efefef" @click="backTop">
        <p class="pl">
          <img v-if="top" src="../../static/images/xiaotubiao/5.png" alt="" />
          <img v-else src="../../static/images/xiaotubiao/10.png" alt="" />
        </p>
      </div>
    </div>
    <div class="fixed_boxs">
      <div class="fixed_box">
        <div class="fixed_box_tit">
          <div class="fixed_box_tit_t">
            扫描二维码
          </div>
          <div class="fixed_box_tit_b">
            关注微信公众号
          </div>
        </div>
        <img class="fixed_box_img" src="../assets/images/erweima2.jpg" alt="">
      </div>
      <div class="fixed_box" v-if="false">
        <div class="fixed_box_tit">
          <div class="fixed_box_tit_t">
            微信咨询
          </div>
        </div>
        <img class="fixed_box_img" src="../../static/images/xiaotubiao/微信(2).jpg" alt="">
      </div>
      <div class="fixed_box" v-if="false">
        <div class="fixed_box_tit">
          <div class="fixed_box_tit_t">
            QQ咨询
          </div>
        </div>
        <img class="fixed_box_img" src="../../static/images/xiaotubiao/qq.png" alt="">
      </div>
      <div class="fixed_box">
        <div class="fixed_box_tit">
          <div class="fixed_box_tit_t">
            下载iPhone版
          </div>
          <div class="fixed_box_tit_b">
            APP
          </div>
        </div>
        <img class="fixed_box_img" src="../../static/images/yfjy_ios.png" alt="">
      </div>
      <div class="fixed_box">
        <div class="fixed_box_tit">
          <div class="fixed_box_tit_t">
            下载Android
          </div>
          <div class="fixed_box_tit_b">
            版APP
          </div>
        </div>
        <img class="fixed_box_img" src="../../static/images/yfjy.png" alt="">
      </div>
      <div class="fixed_box">
        <div class="fixed_box_tit">
            <el-link :href="exeUrl"
              type="primary" style="font-size: 12px;">下载电脑端应用</el-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        official: false, //微信公众号是否显示
        applet: false, //微信小程序是否显示
        service: false, //客服是否显示
        texsd: false,
        official2: false, //微信公众号是否显示
        applet2: false, //微信小程序是否显示
        service2: false, //客服是否显示
        texsd2: false,
        texsd3: false,
        texsd4: false,
        texsexe2: false,
        texsexe: false,
        top: false,
        isShow: false,
        isUserAgent: 0,
        exeUrl: null
      };
    },
    created() {
      this.exeUrl = GlobalVariable.exeUrl;
      this.isUserAgent = this.$config.baseUrl.isUserAgent;
    },
    mounted() {
      this.listenerFunction();
    },
    methods: {
      listenerFunction(e) {
        document.addEventListener("scroll", this.handleScroll, true);
      },
      beforeDestroy() {
        document.removeEventListener("scroll", this.listenerFunction);
      },
      handleScroll() {
        // handleScroll 和 methods 是同级
        if (window.pageYOffset > 300) {
          //window.pageYOffset:获取滚动距离
          this.isShow = true;
        } else {
          this.isShow = false;
        }
      },
      //微信公众号鼠标移入事件
      account() {
        this.official = true;
        this.official2 = true;
      },
      //微信公众号鼠标移出事件
      accountout() {
        this.official = false;
      },
      //微信小程序鼠标移入事件
      mouse() {
        this.applet = true;
        this.applet2 = true;
      },
      //微信小程序鼠标移出事件
      seout() {
        this.applet = false;
      },
      //客服鼠标移入事件
      customer() {
        this.service = true;
        this.service2 = true;
      },
      //客服鼠标移出事件
      customerout() {
        this.service = false;
      },
      //咨询客服鼠标移入
      consulting() {
        this.texsd = true;
        this.texsd2 = true;
      },
      //咨询客服鼠标移入
      consultingomerout() {
        this.texsd = false;
      },
      yfjyting() {
        this.texsd3 = true;
        this.texsd4 = true;
      },
      //咨询客服鼠标移入
      yfjyomerout() {
        this.texsd3 = false;
      },
      exeting() {
        this.texsexe = true;
        this.texsexe2 = true;
      },
      //咨询客服鼠标移入
      exeout() {
        this.texsexe = false;
      },
      //顶部鼠标移入
      topsd() {
        this.top = true;
      },
      //顶部鼠标移入
      topsdomerout() {
        this.top = false;
      },
      //回到顶部功能
      backTop() {
        var timer = setInterval(function () {
          let osTop =
            document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            osTop + ispeed;
          this.isTop = true;
          if (osTop === 0) {
            clearInterval(timer);
          };
        }, 10);
      }
    }
  };
</script>

<style scoped>
  .fixed_boxs {
    z-index: 1111;
    position: fixed;
    right: 0px;
    width: 96px;
    /* top: 20vh; */
    bottom: 0;
    text-align: center;
    color: #000;
  }
  .fixed_box {
    background-color: #fff;
    padding: 5px;
    border-radius: 5px;
    box-shadow: 0 5px 20px #efefef;
    margin-bottom: 10px;
  }
  .fixed_box_tit {
    line-height: 24px;
    margin-bottom: 5px;
    color: #00AEEC;
  }
  .fixed_box_tit_t {
    height: 24px;
    font-size: 14px;
  }
  .fixed_box_tit_b {
    height: 24px;
    font-size: 12px;
  }
  .fixed_box_img {
    width: 86px;
    height: 86px;
  }
  .suspension {
    z-index: 1111;
    position: fixed;
    right: 0px;
    width: 48px;
    top: 40vh;
    font-size: 13.9968px;
    text-align: center;
    color: #000;

  }

  .boxed span {
    display: block;
    overflow: hidden;
    height: 30.0096px;
    line-height: 26px;
  }

  .suspension .boxed {
    width: 100%;
    height: 48px;
    background-color: rgba(255, 255, 255, 100);
    padding-top: 10px;
    cursor: pointer;
    position: relative;
    font-size: 12px;
  }

  .box_span {
    position: absolute;
    width: 24px;
    height: 1px !important;
    background: #F3F5F7;
    bottom: 0px;
    left: 50%;
    margin-left: -12px;
  }

  .suspension .boxed .pl {
    width: 26px;
    height: 26px;
    margin: 0 auto 0;
    padding: 1px;

  }

  .suspension .boxed .pl img {
    width: 100%;
    height: 100%;
  }

  .boxed .tesr {
    width: 0;
    height: 0;
    position: absolute;
    background: rgb(255, 255, 255);
    box-shadow: 0 5px 20px #efefef;
    right: 60px;
    border-radius: 4.992px;
    top: 0px;
    font-size: 12px;
    color: #666666;
    font-weight: 400;
    /* animation: walking 1s; */
    overflow: hidden;
    /* -webkit-animation: resize 0.5s; */
    /* animation: resize 0.2s; */
  }

  /* Chrome, Safari, Opera */
  /* @-webkit-keyframes resize {
  from {
    width: 0px;
    height: 0px
  }

  to {
    width: 144px;
    height: 184px;
  }
} */
  .boxed .xfk2 {
    /* animation: rotate1 1s linear infinite; */
    animation-name: resize1;
    animation-duration: 0.2s;
    animation-timing-function: linear;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }

  .boxed .xfk3 {
    animation-name: resize2;
    padding: 0;
  }

  @keyframes resize1 {
    0% {
      width: 0;
      height: 0
    }

    20% {
      width: 28px;
      height: 36px;
    }

    40% {
      width: 56px;
      height: 72px;
    }

    60% {
      width: 84px;
      height: 108px;
    }

    80% {
      width: 112px;
      height: 144px;
    }

    100% {
      width: 144px;
      height: 184px;
    }
  }

  @keyframes resize2 {
    0% {
      width: 144px;
      height: 184px;
    }

    20% {
      width: 112px;
      height: 144px;
    }

    40% {
      width: 84px;
      height: 108px;
    }

    60% {
      width: 56px;
      height: 72px;
    }

    80% {
      width: 28px;
      height: 36px;
    }

    100% {
      width: 0;
      height: 0;
    }
  }

  @keyframes walking {

    from {
      width: 144px;
      transform: scale(0);
      transform-origin: right top;
    }


    to {
      width: 144px;
      height: 184px;
      transform: scale(1);
    }
  }

  .boxed .tesr .pf {
    width: 120.008px;
    height: 120.008px;
    margin: 8px auto 12px;
  }

  .boxed .tesr .d1 {
    text-align: center;
    margin-top: 10px;
  }

  .boxed .tesr .pf img {
    width: 100%;
    height: 100%;
  }

  .boxed .ters {
    position: absolute;
    width: 12px;
    height: 18.0096px;
    top: 50%;
    right: 80.4px;
    margin-top: -9.0048px;
  }

  .boxed .ters img {
    width: 100%;
    height: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/gotop.vue